import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	iframeContainer: {
		height: '100%',
	},
});
